import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CtaButton } from './ui/CtaButton';
import { Check, X, ArrowRight, Gift } from 'lucide-react';
export function OfferSection() {
  return <section className="w-full px-4 md:px-6" data-id="element-267">
      <div className="max-w-4xl mx-auto space-y-24" data-id="element-268">
        {/* What You Receive */}
        <FadeIn data-id="element-269">
          <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 md:p-12" data-id="element-270">
            <h2 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-271">
              Lo que recibes
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-272">
              <div className="space-y-4" data-id="element-273">
                <div className="flex gap-4" data-id="element-274">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-275">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-276" />
                  </div>
                  <div data-id="element-277">
                    <h3 className="font-bold text-white text-lg" data-id="element-278">
                      Manual del Dinero (ebook)
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-279">
                      Con capítulos profundos, ejemplos y ejercicios.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-280">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-281">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-282" />
                  </div>
                  <div data-id="element-283">
                    <h3 className="font-bold text-white text-lg" data-id="element-284">
                      Plan de implementación
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-285">
                      Paso a paso, sin teoría infinita.
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4" data-id="element-286">
                <div className="flex gap-4" data-id="element-287">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-288">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-289" />
                  </div>
                  <div data-id="element-290">
                    <h3 className="font-bold text-white text-lg" data-id="element-291">
                      Plantillas imprimibles
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-292">
                      Mapa del Dinero, Mapa de Cuentas, Tarjeta "Rol Definido".
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-293">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-294">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-295" />
                  </div>
                  <div data-id="element-296">
                    <h3 className="font-bold text-white text-lg" data-id="element-297">
                      Protocolo Anti-Crisis
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-298">
                      Qué hacer cuando el mundo se pone raro (sin decisiones
                      heroicas).
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Bonuses included */}
            <div className="mt-8 pt-8 border-t border-brand-gold/10" data-id="element-299">
              <div className="flex items-center gap-2 mb-6 justify-center" data-id="element-300">
                <Gift className="w-5 h-5 text-brand-gold" data-id="element-301" />
                <h3 className="text-xl font-bold text-white" data-id="element-302">
                  + 3 BONOS GRATIS INCLUIDOS
                </h3>
              </div>
              <div className="grid md:grid-cols-3 gap-4" data-id="element-303">
                <div className="bg-brand-bg/50 border border-brand-gold/10 rounded-xl p-5 text-center" data-id="element-304">
                  <div className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded inline-block mb-3" data-id="element-305">
                    GRATIS
                  </div>
                  <h4 className="font-bold text-white text-sm mb-1" data-id="element-306">BONO #1</h4>
                  <p className="text-brand-gold text-sm font-medium mb-2" data-id="element-307">
                    Kit "Cero Fricción"
                  </p>
                  <p className="text-brand-muted text-xs" data-id="element-308">
                    Configura tus 4 cuentas en 30 minutos con guías paso a paso.
                  </p>
                </div>
                <div className="bg-brand-bg/50 border border-brand-gold/10 rounded-xl p-5 text-center" data-id="element-309">
                  <div className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded inline-block mb-3" data-id="element-310">
                    GRATIS
                  </div>
                  <h4 className="font-bold text-white text-sm mb-1" data-id="element-311">BONO #2</h4>
                  <p className="text-brand-gold text-sm font-medium mb-2" data-id="element-312">
                    Guía "Anti-Mezcla"
                  </p>
                  <p className="text-brand-muted text-xs" data-id="element-313">
                    Reglas de transferencias y pagos automáticos para no volver
                    a mezclar.
                  </p>
                </div>
                <div className="bg-brand-bg/50 border border-brand-gold/10 rounded-xl p-5 text-center" data-id="element-314">
                  <div className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded inline-block mb-3" data-id="element-315">
                    GRATIS
                  </div>
                  <h4 className="font-bold text-white text-sm mb-1" data-id="element-316">BONO #3</h4>
                  <p className="text-brand-gold text-sm font-medium mb-2" data-id="element-317">
                    Workbook "Ansiedad → Acción"
                  </p>
                  <p className="text-brand-muted text-xs" data-id="element-318">
                    Protocolo de 10 minutos para frenar impulsos financieros.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Who it is for */}
        <FadeIn data-id="element-319">
          <h2 className="text-3xl font-bold text-white mb-10 text-center" data-id="element-320">
            Para quién es (y para quién no)
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-321">
            {/* YES */}
            <div className="bg-brand-green/5 border border-brand-green/20 rounded-xl p-8" data-id="element-322">
              <h3 className="text-brand-green font-bold text-xl mb-6 flex items-center gap-2" data-id="element-323">
                <Check className="w-6 h-6" data-id="element-324" /> Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-325">
                {['Emprendes o trabajas por tu cuenta en Latinoamérica', 'Tus ingresos son variables o irregulares', 'Te afecta el ruido del dólar/noticias/tasas', 'Sientes que te falta control, no ganas', 'Quieres reglas simples, no motivación'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-326">
                    <Check className="w-4 h-4 text-brand-green mt-1 shrink-0" data-id="element-327" />
                    <span data-id="element-328">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* NO */}
            <div className="bg-brand-red/5 border border-brand-red/20 rounded-xl p-8" data-id="element-329">
              <h3 className="text-brand-red font-bold text-xl mb-6 flex items-center gap-2" data-id="element-330">
                <X className="w-6 h-6" data-id="element-331" /> No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-332">
                {["Buscas 'la inversión del año'", 'Quieres trading o promesas de rendimiento', 'Quieres predicciones geopolíticas', 'Te molesta hacerte responsable de tus reglas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-333">
                    <X className="w-4 h-4 text-brand-red mt-1 shrink-0" data-id="element-334" />
                    <span data-id="element-335">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>

        {/* Transformation */}
        <FadeIn data-id="element-336">
          <div className="text-center max-w-2xl mx-auto" data-id="element-337">
            <h2 className="text-3xl font-bold text-white mb-8" data-id="element-338">
              La transformación
            </h2>
            <p className="text-lg text-brand-muted mb-10" data-id="element-339">
              No te prometo que el mundo se calme. Te prometo algo más útil:{' '}
              <br data-id="element-340" />
              <span className="text-white" data-id="element-341">
                Que tu dinero deje de ser un lugar donde se pelean tus
                emociones.
              </span>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-342">
              {[{
              from: 'Improvisar',
              to: 'Ejecutar'
            }, {
              from: 'Reaccionar',
              to: 'Decidir'
            }, {
              from: 'Mezclar',
              to: 'Separar'
            }, {
              from: 'Urgencia',
              to: 'Criterio'
            }].map((item, i) => <div key={i} className="flex items-center justify-between bg-brand-card p-4 rounded border border-brand-bg" data-id="element-343">
                  <span className="text-brand-muted" data-id="element-344">{item.from}</span>
                  <ArrowRight className="w-4 h-4 text-brand-gold" data-id="element-345" />
                  <span className="text-white font-bold" data-id="element-346">{item.to}</span>
                </div>)}
            </div>

            <p className="text-lg text-white font-serif italic mb-8" data-id="element-347">
              "Y cuando el entorno se mueva, tú vas a tener una ventaja: no vas
              a estar tomando decisiones desde el pánico."
            </p>

            <div className="flex justify-center" data-id="element-348">
              <CtaButton onClick={() => document.getElementById('final-cta')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-349">
                Quiero el Manual del Dinero
              </CtaButton>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}